// A page left behind by an account switch gets a 409 account_changed from
// ExpectedUserGuard on every request it makes, then reloads as the real
// account (utils/axios_setup.js). Those 409s are the guard working, not bugs,
// but call sites that report their own failures (Honeybadger.notify(err))
// still sent them, piling into unrelated faults (HB #130636645, #130924494,
// #131096487; one stale page sent 25 in 4 seconds).
//
// Honeybadger notices carry the error's message, not the error, so the
// interceptor leaves a marker on the page and beforeNotify in packs/app.js
// drops 409s for a short window after it. Other errors keep reporting.

export const ACCOUNT_CHANGED_NOISE_WINDOW_MS = 60 * 1000;

const STATUS_409 = /status code 409\b/;

export const markAccountChanged = (now = Date.now()) => {
  if (typeof window === "undefined") return;
  window.__tkcAccountChangedAt = now;
};

export const isAccountChangedNoise = (notice, now = Date.now()) => {
  const context = notice?.context || {};
  const data = context.response_data || context.responseData;
  if (data?.error === "account_changed") return true;

  const markedAt =
    typeof window === "undefined" ? null : window.__tkcAccountChangedAt;
  if (typeof markedAt !== "number") return false;
  const elapsed = now - markedAt;
  if (elapsed < 0 || elapsed > ACCOUNT_CHANGED_NOISE_WINDOW_MS) return false;

  return STATUS_409.test(String(notice?.message || ""));
};
